import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasProactividadAtom, puntajeTotalProactividadAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasProactividad = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalProactividadAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasProactividadAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasProactividad;
